<div class="form-group">
  <label for="exampleFormControlFile1">{{titulo}}</label>
  <input type="file" class="form-control-file" (change)="onfileChangeDecider($event)" hidden #uploader [multiple]="multiple">
  <div class="form-control-file">
    <button class="btn harvest-gold darken-1" (click)="uploader.click()">{{btn}}</button>
  </div>
 
  <div class="row d-flex justify-content-center mx-0 mt-11 mb-20" *ngIf="displayOutput">
    <div class="col-12 col-lg-12 backgroundColor white base p-5 d-flex justify-content-center" style="height: 216px;" *ngFor="let img of image; let i = index">
      <img [src]="img" alt="" class="img-fluid" style="object-fit: contain;">
      <div (click)="remove(i)"><fa-icon [icon]="faTrash" class="fal fa-trash textColor red lighten-1 pointer"></fa-icon></div>
    </div>
  </div>
 
</div>